import { SHAPE_CUTOUTS } from '@/components/Editor/Shared/shapes';

// Vector versions of the former shapes/*.webp overlays, traced 1:1 on their 1920x1920 canvas.
// Only the mat is coloured; the cutout stays transparent and the bevel bands are black at
// opacity (1 - shade), which reproduces the original multiplicative shading on any colour.
export { SHAPE_CUTOUTS };

export const SHAPE_VIEWBOX = '0 0 1920 1920';

export const MAT_PATH = 'M437 215h1047v1490H437z';


export const BEVEL_BANDS = [
    {
        id: 'left',
        x: 446,
        y: 233,
        width: 24,
        height: 1460,
        x1: 446,
        y1: 0,
        x2: 470,
        y2: 0,
        stops: [[0.0208, 0.114], [0.0625, 0.102], [0.1042, 0.07], [0.1458, 0.06], [0.1875, 0.032], [0.3125, 0.032], [0.3542, 0.02], [0.4792, 0.02], [0.5208, 0], [0.9792, 0]],
    },
    {
        id: 'top',
        x: 446,
        y: 215,
        width: 1027,
        height: 18,
        x1: 0,
        y1: 215,
        x2: 0,
        y2: 233,
        stops: [[0.0278, 0], [0.4167, 0], [0.4722, 0.231], [0.5278, 0.715], [0.5833, 0.563], [0.6389, 0.494], [0.6944, 0.443], [0.75, 0.387], [0.8056, 0.228], [0.8611, 0.103], [0.9167, 0.071], [0.9722, 0.036]],
    },
    {
        id: 'bottom',
        x: 446,
        y: 1693,
        width: 1027,
        height: 12,
        x1: 0,
        y1: 1693,
        x2: 0,
        y2: 1705,
        stops: [[0.0417, 0.022], [0.125, 0.106], [0.2083, 0.051], [0.2917, 0], [0.9583, 0]],
    },
    {
        id: 'right',
        x: 1445,
        y: 233,
        width: 28,
        height: 1460,
        x1: 1445,
        y1: 0,
        x2: 1473,
        y2: 0,
        stops: [[0.0179, 0], [0.2679, 0], [0.3036, 0.02], [0.3393, 0.034], [0.375, 0.051], [0.4107, 0.071], [0.4464, 0.097], [0.4821, 0.12], [0.5179, 0.165], [0.5536, 0.195], [0.5893, 0.246], [0.625, 0.289], [0.6607, 0.312], [0.6964, 0.313], [0.7321, 0.322], [0.7679, 0.333], [0.8036, 0.346], [0.8393, 0.319], [0.875, 0.348], [0.9107, 0.441], [0.9464, 0.49], [0.9821, 0.53]],
    },
    {
        id: 'right-edge',
        x: 1473,
        y: 215,
        width: 11,
        height: 1490,
        x1: 1473,
        y1: 0,
        x2: 1484,
        y2: 0,
        stops: [[0.0455, 0.142], [0.1364, 0.03], [0.2273, 0], [0.9545, 0]],
    },
];
